// Word-file glyph: neutral grey square with a bold white "W" — kept
// monochrome to match the thin, brand-neutral icon language used elsewhere
// (prompt bar, result/in-progress cards, Tools tab), not a copy of
// Microsoft's blue/gradient Word branding.
const WordIcon = ({ size = 20, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="32" height="32" rx="7" fill="#6B7280" />
    <text
      x="16"
      y="22.5"
      textAnchor="middle"
      fontFamily="Arial, Helvetica, sans-serif"
      fontWeight="700"
      fontSize="16"
      fill="#FFFFFF"
    >
      W
    </text>
  </svg>
);

export default WordIcon;
